export const SOCIAL = [
	{
		id: 1,
		name: 'Twitter',
		url: 'https://x.com/rndm_io',
		icon: '/twitter.png',
	},
	{
		id: 2,
		name: 'Discord',
		url: 'https://discord.com/invite/rndmio',
		icon: '/discord.png',
	},
	/*{
		id: 1,
		name: 'Telegram',
		url: 'https://t.me/+96H-v4meO1szMmJk',
		icon: '/telegram.svg',
	},*/
];
